var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticStyle:{"text-align":"center"},attrs:{"xs12":""}},[_c('div',{staticStyle:{"background-color":"#DB1918","height":"2px"}},[_vm._v(" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }